"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStudioArt = exports.isPreAP = exports.isDigitalPortfolio = exports.isCapstone = exports.WORLD_HISTORY = exports.US_HISTORY = exports.US_GOVERNMENT = exports.STATISTICS = exports.SPANISH_LITERATURE = exports.SPANISH_LANGUAGE = exports.SEMINAR = exports.RESEARCH = exports.PSYCHOLOGY = exports.PRE_CALCULUS = exports.PRE_AP = exports.PHYSICS_MECHANICS = exports.PHYSICS_ELECTRICITY = exports.PHYSICS_2 = exports.PHYSICS_1 = exports.MUSIC_THEORY = exports.MICROECONOMICS = exports.MACROECONOMICS = exports.LATIN = exports.JAPANESE_LANGUAGE = exports.ITALIAN_LANGUAGE = exports.HUMAN_GEOGRAPHY = exports.GERMAN_LANGUAGE = exports.FRENCH_LANGUAGE = exports.EUROPEAN_HISTORY = exports.ENVIRONMENTAL_SCIENCE = exports.ENGLISH_LITERATURE = exports.ENGLISH_LANGAUGE = exports.COURSE_LABELS = exports.COMPUTER_SCIENCE_PRINCIPLES = exports.COMPUTER_SCIENCE_A = exports.COMPARATIVE_GOVERNMENT = exports.CHINESE_LANGUAGE = exports.CHEMISTRY = exports.CALCULUS_BC = exports.CALCULUS_AB = exports.BIOLOGY = exports.ART_HISTORY = exports.ART_DRAWING = exports.ART_3D = exports.ART_2D = exports.AP = exports.AFRICAN_AMERICAN_STUDIES = void 0;
const US_HISTORY = 1;
exports.US_HISTORY = US_HISTORY;
const ART_HISTORY = 2;
exports.ART_HISTORY = ART_HISTORY;
const ART_DRAWING = 3;
exports.ART_DRAWING = ART_DRAWING;
const ART_2D = 4;
exports.ART_2D = ART_2D;
const ART_3D = 5;
exports.ART_3D = ART_3D;
const BIOLOGY = 6;
exports.BIOLOGY = BIOLOGY;
const CHEMISTRY = 7;
exports.CHEMISTRY = CHEMISTRY;
const COMPUTER_SCIENCE_A = 8;
exports.COMPUTER_SCIENCE_A = COMPUTER_SCIENCE_A;
const MACROECONOMICS = 10;
exports.MACROECONOMICS = MACROECONOMICS;
const MICROECONOMICS = 11;
exports.MICROECONOMICS = MICROECONOMICS;
const ENGLISH_LANGAUGE = 12;
exports.ENGLISH_LANGAUGE = ENGLISH_LANGAUGE;
const ENGLISH_LITERATURE = 13;
exports.ENGLISH_LITERATURE = ENGLISH_LITERATURE;
const ENVIRONMENTAL_SCIENCE = 14;
exports.ENVIRONMENTAL_SCIENCE = ENVIRONMENTAL_SCIENCE;
const EUROPEAN_HISTORY = 15;
exports.EUROPEAN_HISTORY = EUROPEAN_HISTORY;
const FRENCH_LANGUAGE = 16;
exports.FRENCH_LANGUAGE = FRENCH_LANGUAGE;
const HUMAN_GEOGRAPHY = 18;
exports.HUMAN_GEOGRAPHY = HUMAN_GEOGRAPHY;
const GERMAN_LANGUAGE = 19;
exports.GERMAN_LANGUAGE = GERMAN_LANGUAGE;
const US_GOVERNMENT = 20;
exports.US_GOVERNMENT = US_GOVERNMENT;
const COMPARATIVE_GOVERNMENT = 21;
exports.COMPARATIVE_GOVERNMENT = COMPARATIVE_GOVERNMENT;
const LATIN = 23;
exports.LATIN = LATIN;
const CALCULUS_AB = 25;
exports.CALCULUS_AB = CALCULUS_AB;
const CALCULUS_BC = 26;
exports.CALCULUS_BC = CALCULUS_BC;
const MUSIC_THEORY = 27;
exports.MUSIC_THEORY = MUSIC_THEORY;
const PHYSICS_MECHANICS = 29;
exports.PHYSICS_MECHANICS = PHYSICS_MECHANICS;
const PSYCHOLOGY = 30;
exports.PSYCHOLOGY = PSYCHOLOGY;
const SPANISH_LANGUAGE = 31;
exports.SPANISH_LANGUAGE = SPANISH_LANGUAGE;
const SPANISH_LITERATURE = 32;
exports.SPANISH_LITERATURE = SPANISH_LITERATURE;
const STATISTICS = 33;
exports.STATISTICS = STATISTICS;
const WORLD_HISTORY = 34;
exports.WORLD_HISTORY = WORLD_HISTORY;
const PHYSICS_ELECTRICITY = 78;
exports.PHYSICS_ELECTRICITY = PHYSICS_ELECTRICITY;
const ITALIAN_LANGUAGE = 86;
exports.ITALIAN_LANGUAGE = ITALIAN_LANGUAGE;
const CHINESE_LANGUAGE = 87;
exports.CHINESE_LANGUAGE = CHINESE_LANGUAGE;
const JAPANESE_LANGUAGE = 88;
exports.JAPANESE_LANGUAGE = JAPANESE_LANGUAGE;
const PHYSICS_1 = 92;
exports.PHYSICS_1 = PHYSICS_1;
const PHYSICS_2 = 93;
exports.PHYSICS_2 = PHYSICS_2;
const SEMINAR = 94;
exports.SEMINAR = SEMINAR;
const RESEARCH = 95;
exports.RESEARCH = RESEARCH;
const COMPUTER_SCIENCE_PRINCIPLES = 103;
exports.COMPUTER_SCIENCE_PRINCIPLES = COMPUTER_SCIENCE_PRINCIPLES;
const AFRICAN_AMERICAN_STUDIES = 116;
exports.AFRICAN_AMERICAN_STUDIES = AFRICAN_AMERICAN_STUDIES;
const PRE_CALCULUS = 117;
exports.PRE_CALCULUS = PRE_CALCULUS;
const PRE_AP = 'T';
exports.PRE_AP = PRE_AP;
const AP = 'A';
exports.AP = AP;

const isCapstone = function (_ref) {
  let testCd = _ref.testCd;
  return testCd === SEMINAR || testCd === RESEARCH;
};

exports.isCapstone = isCapstone;

const isDigitalPortfolio = function (c) {
  return isCapstone(c) || c.testCd === COMPUTER_SCIENCE_PRINCIPLES;
};

exports.isDigitalPortfolio = isDigitalPortfolio;

const isStudioArt = function (_ref2) {
  let testCd = _ref2.testCd;
  return testCd === ART_DRAWING || testCd === ART_2D || testCd === ART_3D;
};

exports.isStudioArt = isStudioArt;

const isPreAP = function (_ref3) {
  let testProgramCd = _ref3.testProgramCd;
  return testProgramCd === PRE_AP;
};

exports.isPreAP = isPreAP;
const COURSE_LABELS = {
  [US_HISTORY]: 'AP United States History',
  [ART_HISTORY]: 'AP Art History',
  [ART_DRAWING]: 'AP Drawing',
  [ART_2D]: 'AP 2-D Art and Design',
  [ART_3D]: 'AP 3-D Art and Design',
  [BIOLOGY]: 'AP Biology',
  [CHEMISTRY]: 'AP Chemistry',
  [COMPUTER_SCIENCE_A]: 'AP Computer Science A',
  [MACROECONOMICS]: 'AP Macroeconomics',
  [MICROECONOMICS]: 'AP Microeconomics',
  [ENGLISH_LANGAUGE]: 'AP English Language and Composition',
  [ENGLISH_LITERATURE]: 'AP English Literature and Composition',
  [ENVIRONMENTAL_SCIENCE]: 'AP Environmental Science',
  [EUROPEAN_HISTORY]: 'AP European History',
  [FRENCH_LANGUAGE]: 'AP French Language and Culture',
  [HUMAN_GEOGRAPHY]: 'AP Human Geography',
  [GERMAN_LANGUAGE]: 'AP German Language and Culture',
  [US_GOVERNMENT]: 'AP United States Government and Politics',
  [COMPARATIVE_GOVERNMENT]: 'AP Comparative Government and Politics',
  [LATIN]: 'AP Latin',
  [CALCULUS_AB]: 'AP Calculus AB',
  [CALCULUS_BC]: 'AP Calculus BC',
  [MUSIC_THEORY]: 'AP Music Theory',
  [PHYSICS_MECHANICS]: 'AP Physics C: Mechanics',
  [PSYCHOLOGY]: 'AP Psychology',
  [SPANISH_LANGUAGE]: 'AP Spanish Language and Culture',
  [SPANISH_LITERATURE]: 'AP Spanish Literature and Culture',
  [STATISTICS]: 'AP Statistics',
  [WORLD_HISTORY]: 'AP World History: Modern',
  [PHYSICS_ELECTRICITY]: 'AP Physics C: Electricity and Magnetism',
  [ITALIAN_LANGUAGE]: 'AP Italian Language and Culture',
  [CHINESE_LANGUAGE]: 'AP Chinese Language and Culture',
  [JAPANESE_LANGUAGE]: 'AP Japanese Language and Culture',
  [PHYSICS_1]: 'AP Physics 1: Algebra-Based',
  [PHYSICS_2]: 'AP Physics 2: Algebra-Based',
  [SEMINAR]: 'AP Seminar',
  [RESEARCH]: 'AP Research',
  [COMPUTER_SCIENCE_PRINCIPLES]: 'AP Computer Science Principles',
  [AFRICAN_AMERICAN_STUDIES]: 'AP African American Studies',
  [PRE_CALCULUS]: 'AP Precalculus'
};
exports.COURSE_LABELS = COURSE_LABELS;